@if (products) {
  <header>
    <div class="heading">
      {{ heading }}
    </div>
    <div [innerHTML]="subheading" class="subheading"></div>
  </header>

  @if (!isSubscriptionManual) {
    <rt-assigned-product-message-container />
  }

  <rt-spam-verification-infobox-container />

  <div class="toolbar box">
    <rt-plan-picker-2024-toolbar
      [interval]="interval"
      [enableCurrencyChange]="showCurrencyControl"
      [enableIntervalChange]="showIntervalControl"
      [companySize]="companySize"
      [minimalCompanySize]="minimalCompanySize"
      [sizeSelectMode]="sizeSelectMode"
      [currency]="currency"
      (companySizeChange)="changeCompanySize($event)"
      (currencyChange)="changeCurrency($event)"
      (intervalChange)="changeInterval($event)"
    />
  </div>

  <div [class.tr-radius-0]="viewMode === ViewMode.StaffingAgency" class="main-content box">
    <rt-plan-picker-2024-products
      [viewMode]="viewMode"
      [products]="products"
      [currency]="currency"
      [interval]="interval"
      [showTrialBadge]="isTrial"
      [showSlotsLimitMessage]="showSlotsLimitMessage"
      [startPlanSlotsLimit]="startPlanSlotsLimit"
      (chooseProduct)="chooseProduct($event)"
      (cancelSubscription)="cancelSubscription()"
    />
    <rt-plan-picker-2024-compare [viewMode]="viewMode" />
  </div>
  <div class="footer box">
    <rt-plan-picker-2024-footer />
  </div>
}
